"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPostMessageIdEvent = void 0;
/* eslint-disable camelcase */
var EPostMessageIdEvent;
(function (EPostMessageIdEvent) {
    EPostMessageIdEvent["open"] = "signIn";
    EPostMessageIdEvent["signUp"] = "signUp";
    EPostMessageIdEvent["fullSignUp"] = "fullSignUp";
    EPostMessageIdEvent["pageChange"] = "pageChange";
    EPostMessageIdEvent["close"] = "close";
})(EPostMessageIdEvent || (exports.EPostMessageIdEvent = EPostMessageIdEvent = {}));
//# sourceMappingURL=AuthMessageProvider.types.js.map